import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { debug } from 'console';
import {  ADPResourceService, CustomFormControl, StorageService } from 'digital-core';
import { EncryptionService } from 'src/app/core/services/encryption.service';
import { PGHAPIService } from 'src/app/core/services/pgh-api-service';

@Component({
  selector: 'pgh-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {
  invalidPassword = false;
  isLoggedIn = false;
  contentEditorEmail : string = '';
  errorKey: string = '';

	public form = new FormGroup({
		Email: new CustomFormControl(),
		Password: new CustomFormControl()
	});

  constructor(
		public resourceService: ADPResourceService,
    public storageService: StorageService,
    public encriptionService: EncryptionService,
    public router: Router,
    public route: ActivatedRoute,
    public pghapiService: PGHAPIService
	) {}

  ngOnInit(): void {

    if (!this.resourceService.isPortalSettingTrue('Global_Feature_ContentEditor_IsEnabled')) {
      this.router.navigateByUrl('/error');
    }
    this.isLoggedIn = this.isContentEditorLoggedIn();
    if(this.isLoggedIn) {
       this.contentEditorEmail = this.storageService.getLocal('content-editor-email');
    }
  }

  isContentEditorLoggedIn(): boolean {
    let email = this.storageService.getLocal<string>('content-editor-email');
    if (email === null) {
      return false;
    } else {
      return true;
    }
  }

  getResourceObject(name: string, namespace = null) {
		namespace = namespace ? namespace : 'Editor';
		let title = namespace + '_' + name;
		let resourceValue = this.resourceService.getViewResourceObject(title);
		return resourceValue;
	}

  login(){
    this.errorKey = null;
    this.pghapiService.post('resource/EditorLogin', { email :this.form.get('Email').value,
    password: this.form.get('Password').value
    }, ).subscribe(
      (res: string) => {
        if(res.indexOf('Error')==-1) {
          this.isLoggedIn = true;
          this.storageService.setLocal('content-editor-id', res, true);
          this.storageService.setLocal('content-editor-email', this.form.get('Email').value, true);
          this.contentEditorEmail = this.form.get('Email').value;
        } else {
          this.errorKey = res;
        }
      });;
  }

  logout() {
    this.storageService.setLocal('content-editor-id', null, true);
    this.storageService.setLocal('content-editor-email', null, true);
    this.isLoggedIn = false;
  }

}
